import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { EQUIPMENT_SET, EQUIPMENT_SINGLE_SET } from './constants';
import { EquipmentState, EquipmentActions } from './types';

const initialState: EquipmentState = {};

export default function (
    state: EquipmentState = initialState,
    action: EquipmentActions
): EquipmentState {
    switch (action.type) {
        case EQUIPMENT_SET:
            return get(action, 'payload', {});
        case EQUIPMENT_SINGLE_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
